// src/components/StatisticsTab.js
import React from 'react';

const StatisticsTab = ({
  students,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  getDetailedStats,
  sundayDates,
  catechismAttendanceDates,
  weekdayDates,
}) => {
  return (
    <>
      <h4>Thống kê chuyên cần chi tiết</h4>
      <div className="stats-date-range-filter">
        <label>
          Từ ngày:
          <input
            type="date"
            className="stats-date-input"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
        </label>
        <label>
          Đến ngày:
          <input
            type="date"
            className="stats-date-input"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
        </label>
        <button
          className="clear-filter-btn"
          onClick={() => { setStartDate(''); setEndDate(''); }}
        >
          Xóa lọc
        </button>
      </div>

      <div className="table-wrapper">
        <table className="student-table stats-table">
          <thead>
            <tr>
              <th rowSpan="2">Stt</th>
              <th rowSpan="2">ID</th>
              <th rowSpan="2">Tên Thánh</th>
              <th rowSpan="2" className="sticky-name-col">Họ và Tên</th>
              <th colSpan="3" style={{ backgroundColor: '#0056b3' }}>Vắng Lễ Chúa Nhật</th>
              <th colSpan="3" style={{ backgroundColor: '#ffc107', color: '#000' }}>Vắng Học Giáo Lý</th>
              <th colSpan="3" style={{ backgroundColor: '#28a745' }}>Vắng Lễ Ngày Thường</th>
            </tr>
            <tr>
              <th style={{ fontSize: '11px' }}>Tổng</th>
              <th style={{ backgroundColor: '#ffc107', color: '#000', fontSize: '11px' }}>Phép</th>
              <th style={{ backgroundColor: '#ff0000', fontSize: '11px' }}>K.Phép</th>

              <th style={{ fontSize: '11px' }}>Tổng</th>
              <th style={{ backgroundColor: '#ffc107', color: '#000', fontSize: '11px' }}>Phép</th>
              <th style={{ backgroundColor: '#ff0000', fontSize: '11px' }}>K.Phép</th>

              <th style={{ fontSize: '11px' }}>Tổng</th>
              <th style={{ backgroundColor: '#ffc107', color: '#000', fontSize: '11px' }}>Phép</th>
              <th style={{ backgroundColor: '#ff0000', fontSize: '11px' }}>K.Phép</th>
            </tr>
          </thead>
          <tbody>
            {students.map((student, index) => {
              const sunStats = getDetailedStats(student.attendance, sundayDates, startDate, endDate);
              const glStats = getDetailedStats(student.catechismAttendance, catechismAttendanceDates, startDate, endDate);
              const weekStats = getDetailedStats(student.attendance, weekdayDates, startDate, endDate);

              return (
                <tr key={student.id || index}>
                  <td>{index + 1}</td>
                  <td style={{ fontFamily: 'monospace' }}>{student.id}</td>
                  <td>{student.holyName || '-'}</td>
                  <td className="sticky-name-col" style={{ textAlign: 'left', fontWeight: '500' }}>{student.fullName}</td>

                  <td style={{ fontWeight: 'bold' }}>{sunStats.total}</td>
                  <td style={{ color: '#856404' }}>{sunStats.excused}</td>
                  <td style={{ color: '#dc3545' }}>{sunStats.unexcused}</td>

                  <td style={{ fontWeight: 'bold' }}>{glStats.total}</td>
                  <td style={{ color: '#856404' }}>{glStats.excused}</td>
                  <td style={{ color: '#dc3545' }}>{glStats.unexcused}</td>

                  <td style={{ fontWeight: 'bold' }}>{weekStats.total}</td>
                  <td style={{ color: '#856404' }}>{weekStats.excused}</td>
                  <td style={{ color: '#dc3545' }}>{weekStats.unexcused}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default StatisticsTab;